<template>
    <div class="row">
        <div class="col-12 px-0">
            <ul class="qf-dashboard-navigation">
                <li class="qf-active-nav">
                    <a href="#!" @click.prevent>
                        {{$ml.get('reports')}}
                    </a>
                </li>
                <li v-if="loading">
                    <a @clisk.prevent>
                        <font-awesome-icon icon="spinner" class="fa-spin"/>
                    </a>
                </li>
                <li></li>
            </ul>
        </div>
        <div class="col-6">
            <a href="/dashboard/reports" @click.prevent="$router.back()" class="small">
                <font-awesome-icon icon="chevron-left"/>
                {{$ml.get('Back')}}
            </a>
        </div>
        <div class="col-6 d-flex">
            <div class="flex-grow-1"></div>
            <div class="d-flex align-items-center">
                <label for="showHidden" class="d-block mr-2 mb-0 flex-grow-0">{{$ml.get('Show_Hidden')}}</label>
                <label class="qf-switch">
                    <input type="checkbox" name="showHidden" v-model="showHidden" id="showHidden">
                    <span class="qf-switch-dot"></span>
                    <span class="qf-switch-on">{{$ml.get('Yes')}}</span>
                    <span class="qf-switch-off">{{$ml.get('No')}}</span>
                </label>
            </div>
        </div>

        <div class="col-12 h2 pt-5 text-center" v-if="loading">
            <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
        </div>
        <div class="col-12 pt-3" v-else>
            <div class="table-responsive">
                <table class="table qf-table qf-border-space text-center">
                    <thead>
                    <tr class="qf-table-title">
                        <th>{{$ml.get('Result')}}</th>
                        <th>
                            <div class="p-0 d-flex">
                                <div class="w-50 flex-grow-1">
                                    {{$ml.get('Matching')}}
                                </div>
                                <div class="w-50 flex-grow-1">
                                    {{$ml.get('NCL')}}
                                </div>
                            </div>
                        </th>
                        <th class="qf-w-50px">{{$ml.get('Time_to_respond')}}</th>
                        <th>{{$ml.get('Monitored_trademark')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="qf-h-50px qf-clickable"
                        v-for="(reportRow, index) in filterReports"
                        :key="`report${index}`"
                        @click="matchDetails(reportRow.id)">
                        <td class="py-2 px-1">
                            <div class="d-flex flex-column flex-md-row align-items-center">
                                <div class="w-25 pl-2 pr-2">
                                    <div class="qf-w-50px qf-brand-logo text-center mx-auto">
                                        <img :src="`${$store.state.baseUrl}${reportRow.matched_trademark.logo}`"
                                             alt="logo" class="img-fluid"
                                             v-if="reportRow.matched_trademark.logo !== undefined && reportRow.matched_trademark.logo.length">
                                        <img src="../../../assets/img/placeholders/logo.png" alt="logo"
                                             class="img-fluid" v-else>
                                    </div>
                                </div>
                                <div class="w-75 qf-title-box">
                                    {{reportRow.matched_trademark.title}}
                                </div>
                            </div>
                        </td>
                        <td class="py-2 px-1 qf-w-175px">
                            <div class="p-0 d-flex align-items-center">
                                <div class="d-flex flex-wrap align-items-center justify-content-center w-50 flex-grow-1">
                                    <image-icon height="21" width="21" iconColor=""
                                                class="qf-va-sub d-block w-50 qf-border-right px-2 qf-svg"
                                                :class="{'qf-svg-non-active': !reportRow.vienna_match}"></image-icon>
                                    <text-icon height="20" width="20" iconColor=""
                                               class="qf-va-sub d-block w-50 qf-border-right px-2 qf-svg"
                                               :class="{'qf-svg-non-active': !reportRow.title_match}"></text-icon>
                                </div>
                                <div class="px-2 small w-50 flex-grow-1 text-center">
                                    {{reportRow.matched_nice_classes | arrayToString}}
                                </div>
                            </div>
                        </td>
                        <td class="py-2 px-1">{{reportRow.days_to_respond}} {{$ml.get('days')}}</td>
                        <td class="py-2 px-1">
                            <div class="d-flex flex-column flex-md-row align-items-center">
                                <div class="w-25">
                                    <div class="qf-w-50px qf-brand-logo text-center mx-auto">
                                        <img :src="`${$store.state.baseUrl}${reportRow.user_trademark.logo_path}`"
                                             alt="logo" class="img-fluid"
                                             v-if="reportRow.user_trademark.logo_path !== undefined && reportRow.user_trademark.logo_path.length">
                                        <img src="../../../assets/img/placeholders/logo.png" alt="logo"
                                             class="img-fluid" v-else>
                                    </div>
                                </div>
                                <div class="w-50">
                                    {{reportRow.user_trademark.title}}
                                </div>
                                <div class="w-25">
                                    <font-awesome-icon icon="spinner" class="fa-spin" size="2x"
                                                       v-if="statusLoaders.includes(reportRow.id)"/>
                                    <a href="#!" class="qf-svg-link" @click.prevent.stop="changeStatus(reportRow)"
                                       v-else>
                                        <archive-icon height="18" width="18" iconColor="" class="qf-va-sub"
                                                      :class="{'qf-svg-non-active': !reportRow.active}"></archive-icon>
                                    </a>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'reportDetails',
        filters: {
            arrayToString(value) {
                if (value === undefined) {
                    return '';
                }
                return value.join(', ')
            }
        },
        props: {
            id: {
                type: [Number, String],
            },
            ownerId: {
                type: [Number, String]
            },
            brandId: {
                type: [Number, String]
            }
        },
        computed: {
            filterReports() {
                if (!this.showHidden) {
                    return this.report.filter(obj => {
                        return obj.active === true;
                    });
                }
                return this.report;
            }
        },
        data() {
            return {
                report: [],
                showHidden: true,
                statusLoaders: [],
                loading: false
            }
        },
        mounted() {
            this.loading = true;

            let queryParams = ``;

            if (this.ownerId && this.ownerId !== -1) {
                queryParams += `?owner=${this.ownerId}`;
                if (this.brandId && this.brandId !== -1) {
                    queryParams += `&brand=${this.brandId}`;
                }
            }

            this.$store.dispatch('report', {id: this.id, queryParams: queryParams}).then(response => {
                this.report = response;
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        methods: {
            matchDetails(id) {
                this.$router.push({name: 'SingleReport', params: {id: id}});
            },
            changeStatus(row) {
                if (!this.statusLoaders.includes(row.id)) {
                    this.statusLoaders.push(row.id);
                    this.$store.dispatch('changeMatchStatus', row.id).then(() => {
                        row.active = !row.active;
                        this.removeFromStatusLoaders(row.id);
                    }).catch(() => {
                        this.removeFromStatusLoaders(row.id);
                    });
                }
            },
            removeFromStatusLoaders(id) {
                let statusLoaderIndex = this.statusLoaders.findIndex(item => {
                    return item === id;
                });
                if (statusLoaderIndex > -1) {
                    this.statusLoaders.splice(statusLoaderIndex, 1);
                }
            }
        }
    }
</script>

<style scoped>
    .qf-border-space {
        border-spacing: 3px 2px;
    }

    .qf-table-title th {
        vertical-align: middle;
    }

    .qf-brand-logo img {
        max-height: 40px;
    }

    .qf-border-right {
        border-right: 1px solid #AEBCC2;
    }

    .qf-svg,
    .qf-svg-link svg {
        fill: #001529;
    }

    .qf-svg-link:hover svg {
        fill: #4D7B8F;
    }

    .qf-svg.qf-svg-non-active,
    .qf-svg-link svg.qf-svg-non-active {
        fill: #d8d8d8;
    }

    .qf-svg-link:hover svg.qf-svg-non-active {
        fill: #8C8C8C;
    }

    .qf-title-box {
        max-width: 280px;
    }

    .flex-column.flex-md-row .w-25,
    .flex-column.flex-md-row .w-50,
    .flex-column.flex-md-row .w-75 {
        width: 100% !important;
    }

    @media (min-width: 576px) {
    }


    @media (min-width: 768px) {
        .flex-column.flex-md-row .w-25 {
            width: 25% !important;
        }

        .flex-column.flex-md-row .w-50 {
            width: 50% !important;
        }

        .flex-column.flex-md-row .w-75 {
            width: 75% !important;
        }
    }
</style>
